export const businessTranslations = {
  BUSINESS_TITLE: 'Zakelijk',
  BUSINESS_SUBTITLE: 'Tranzer voor jou werknemers',
};
